import React, { useEffect, useState, useMemo } from 'react';
import { Modal, Button, Row, Spinner, Alert } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { alertActions, adminActions } from '../../redux/_actions';
import TeamForm from './teamform';
import TeamDetail from './teamdetail';
import TableComponent from '../helpers/tablecomponent';

const modeType = {
  ADD: 'ADD',
  EDIT: 'EDIT',
  DELETE: 'DELETE',
  LIST: 'LIST',
  DETAIL: 'DETAIL',
};

function TeamAdmin(props) {
  const { setIsForm } = props;
  const [isLoading, setIsLoading] = useState(true);
  const [mode, setMode] = useState(modeType.LIST);
  const [teamId, setTeamId] = useState(null);
  const { alert } = useSelector((state) => state);
  const { teams, rosters, rosterLinks, leagues } = useSelector(
    (state) => state.admin
  );
  const dispatch = useDispatch();

  useEffect(() => {
    if (!alert.clear) {
      setIsLoading(false);
    }
  }, [alert.clear]);

  useEffect(() => {
    dispatch(alertActions.clear());
  }, [dispatch]);

  useEffect(() => {
    if (teams.byId.length === 0) {
      setIsLoading(true);
      dispatch(adminActions.getTeams());
    } else {
      setIsLoading(false);
    }
  }, [teams, dispatch]);

  const teamDetail = (e, row) => {
    if (!alert.clear) {
      dispatch(alertActions.clear());
    }
    setTeamId(row.id);
    setMode(modeType.DETAIL);
    setIsForm(true);
  };

  const back = () => {
    setMode(modeType.LIST);
    setIsForm(false);
  };

  const add = () => {
    if (!alert.clear) {
      dispatch(alertActions.clear());
    }
    setMode(modeType.ADD);
    setIsForm(true);
  };

  const loading = () => {
    return (
      <Row
        style={{ margin: '1rem -15px', minHeight: '20vh', textAlign: 'center' }}
        className="vCenter"
      >
        <div className="vCenter" style={{ margin: '0 auto' }}>
          <Spinner
            variant="secondary"
            role="status"
            animation="border"
            size="md"
          />
        </div>
      </Row>
    );
  };

  const emptyList = () => {
    return (
      <Row
        style={{ margin: '1rem -15px', minHeight: '20vh', textAlign: 'center' }}
        className="vCenter"
      >
        <span>No teams created.</span>
      </Row>
    );
  };

  const headers = useMemo(
    () => [
      { Header: '#', accessor: 'col1' },
      { Header: 'Name', accessor: 'col2' },
      { Header: 'Type', accessor: 'col3' },
      { Header: 'Gender', accessor: 'col4' },
      { Header: 'Athletes', accessor: 'col5' },
      { Header: 'League', accessor: 'col6' },
    ],
    []
  );

  const data = useMemo(() => {
    const checkRosterSize = (roster) => {
      return roster.athletes.items.filter((id) => rosterLinks.byId[id].active)
        .length;
    };

    return teams.allIds.map((id, i) => {
      const { name, type, gender } = teams.byId[id];
      const currentRoster = teams.byId[id].rosters.items
        ? rosters.byId[teams.byId[id].rosters.items[0]]
        : null;
      const currentLeague = teams.byId[id].leagues.items
        ? leagues.byId[teams.byId[id].leagues.items[0]]
        : null;

      return {
        col1: i + 1,
        col2: name,
        col3: type,
        col4: gender,
        col5: currentRoster ? checkRosterSize(currentRoster) : 'N/A',
        col6: currentLeague ? currentLeague.name : 'N/A',
        id: id,
      };
    });
  }, [teams, rosterLinks.byId, leagues.byId, rosters.byId]);

  const table = () => {
    const initialState = {
      sortBy: [{ id: 'col2', desc: false }],
    };

    return teams.allIds.length === 0 ? (
      emptyList()
    ) : (
      <TableComponent
        columns={headers}
        data={data}
        onClick={teamDetail}
        initialState={initialState}
        textSort={true}
      />
    );
  };

  const adminBody = () => {
    return (
      <>
        {!alert.clear ? (
          <Row style={{ padding: '0 15px', margin: '1rem -15px' }}>
            <Alert
              dismissible
              onClose={() => dispatch(alertActions.clear())}
              variant={alert.type === 'alert-danger' ? 'danger' : 'success'}
              style={{ textAlign: 'center', width: '100%' }}
            >
              {alert.message}
            </Alert>
          </Row>
        ) : null}
        {isLoading ? loading() : table()}
      </>
    );
  };

  const footer = () => {
    return (
      <>
        <Row className="vCenter" style={{ margin: '0 auto' }}>
          <Button
            variant="outline-primary"
            className="formButton"
            onClick={add}
            disabled={isLoading}
          >
            Add team
          </Button>
        </Row>
        <Row />
      </>
    );
  };

  const headerMsg = () => {
    return <span>Team Admin</span>;
  };

  const listModal = () => {
    return (
      <>
        <Modal.Header className="setupHeader">{headerMsg()}</Modal.Header>
        <Modal.Body className="setupForm">{adminBody()}</Modal.Body>
        <Modal.Footer className="setupFooter">{footer()}</Modal.Footer>
      </>
    );
  };

  const modal = () => {
    switch (mode) {
      case modeType.ADD:
        return <TeamForm back={back} />;
      case modeType.EDIT:
        break;
      case modeType.DELETE:
        break;
      case modeType.LIST:
        return listModal();
      case modeType.DETAIL:
        return <TeamDetail back={back} teamId={teamId} />;
      default:
        return null;
    }
  };

  return modal();
}

export default TeamAdmin;
